<template>
  <v-card
    style="border-radius: 0 !important;"
    @keyup.enter="doRequestInvite"
  >
    <v-card-title
      class="primary--text font-weight-thin mb-5"
    >
      Request Invite
    </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="name"
        :disabled="isComplete || isLoading"
        outlined
        type="text"
        label="Name"
        dense
      />
      <v-text-field
        v-model="email"
        :disabled="isComplete || isLoading"
        outlined
        type="email"
        label="Email"
        dense
      />

      <v-divider class="my-5" />

      <v-btn
        :loading="isLoading && !isComplete"
        :disabled="isComplete"
        block
        color="primary"
        class="accent--text"
        @click="doRequestInvite"
      >
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'

export default {
  components: {},
  data() {
    return {
      email: '',
      name: '',
      isLoading: false,
      isComplete: false,
    }
  },
  computed: {
    buttonText() {
      return this.isComplete
        ? 'Request sent'
        : 'Send Request'
    }
  },
  methods: {
    ...mapActions([ 'requestPlatformInvite' ]),
    async doRequestInvite() {
      this.isLoading = true

      const payload = {
        email: this.email,
        name: this.name
      }

      await this.requestPlatformInvite(payload)
        .then(() => {
          this.isComplete = true
        })
      this.isLoading = false
    }
  }
}
</script>
